import React from "react";

import Breadcrumbs from "./Breadcrumbs";
import InfoPanel from "./InfoPanel";

import type { JSX, ReactNode } from "react";

interface BreadcrumbItem {
  name?: ReactNode;
  url?: string;
}

interface FormNavigationHeaderProps {
  breadcrumbs?: BreadcrumbItem[];
  links?: {
    en: string;
    fr: string;
  };
}

function FormNavigationHeader({
  breadcrumbs,
  links,
}: FormNavigationHeaderProps): JSX.Element {
  return (
    <div className="editor-form-nav">
      <div className="editor-form-nav-left">
        {!!breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
        {!!links && <InfoPanel links={links} />}
      </div>
    </div>
  );
}

export default FormNavigationHeader;
